import React from 'react';
import { Table } from 'react-bootstrap';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';
import { ISortSummaryData, ISortSummaryDataCategory } from '../../api/SortsummaryData';

export interface ISorterSummaryPreviewProps {
  date: {
    month: number;
    year: number;
  };
  sorterName: string;
  summary: ISortSummaryData;
  onSend: () => void;
  onCancel: () => void;
}

const SorterSummaryPreview: React.FunctionComponent<ISorterSummaryPreviewProps> = (props: ISorterSummaryPreviewProps) => {

  const renderRow = (name: string, row: ISortSummaryDataCategory, isHeader: boolean = false) => {
    return (
      <tr className={isHeader ? 'category' : 'catrow'}>
        { isHeader ?
          <th className="categoryName" scope="row"><FormattedMessage id={name}/></th>
        :
          <td className="rowName"><FormattedMessage id={name}/></td>
        }
        <td className="valueCell"><div className="value"><FormattedNumber value={row['EUR']} maximumFractionDigits={2} minimumFractionDigits={2}/></div></td>
        <td><FormattedMessage id="sortsummaryreports.import.resulttable.eur"/></td>
        <td className="valueCell"><div className="value"><FormattedNumber value={row['KG']} maximumFractionDigits={2} minimumFractionDigits={2}/></div></td>
        <td><FormattedMessage id="sortsummaryreports.import.resulttable.kg"/></td>
        <td className="valueCell"><div className="value"><FormattedNumber value={row['EUR/KG']} maximumFractionDigits={3} minimumFractionDigits={3}/></div></td>
        <td><FormattedMessage id="sortsummaryreports.import.resulttable.eurKg"/></td>
      </tr>
    );
  }

  const calculateEurPerKg = (eur: number, kg: number) => {
    return kg > 0 ? eur / kg : 0;
  }

  return (
    <div className="sortReportImportResult generalReportImportResult">
      <div className="d-flex flex-md-row flex-column-reverse">
        <div className="reportResultHeader">
          <h3 className="monthRange">
            <FormattedDate
                value={new Date(props.date.year, props.date.month)}
                month="long"
                year="numeric"
              />
          </h3>
          <h3 className="reportHeader">
            <FormattedMessage id="transportsummaryreports.import.handlingreport"/>
          </h3>
        </div>
        <div className="handlerNameHeader text-right ml-md-auto">
          <h1 className="float-right">{props.sorterName}</h1>
        </div>
      </div>


      <div className="checkSum borderless table-responsive noshadow" >
        <Table className="table table-sm summary-table">
        <tbody>
          <tr>
            <th colSpan={7} scope="row" className="sumHeader"><FormattedMessage id="sortsummaryreports.import.resulttable.header"/></th>
          </tr>
          <tr>
            <th colSpan={7} scope="row"><FormattedMessage id="sortsummaryreports.import.resulttable.WEEE1"/></th>
          </tr>
          { renderRow('sortsummaryreports.import.resulttable.lda', props.summary.WEEE1.LDA) }
          { renderRow('sortsummaryreports.import.resulttable.cold', props.summary.WEEE1.COLD) }
          { renderRow('sortsummaryreports.import.resulttable.scrap', props.summary.WEEE1.SCRAP) }
          { renderRow('sortsummaryreports.import.resulttable.solar', props.summary.WEEE1.SOLARPANELS) }
          <tr>
            <th colSpan={7} scope="row"><FormattedMessage id="sortsummaryreports.import.resulttable.WEEE2"/></th>
          </tr>
          { renderRow('sortsummaryreports.import.resulttable.sda', props.summary.WEEE2.SDA) }
          { renderRow('sortsummaryreports.import.resulttable.scrap', props.summary.WEEE2.SCRAP) }
          <tr>
            <th colSpan={7} scope="row"><FormattedMessage id="sortsummaryreports.import.resulttable.WEEE3"/></th>
          </tr>
          { renderRow('sortsummaryreports.import.resulttable.ict', props.summary.WEEE3.ICT) }
          { renderRow('sortsummaryreports.import.resulttable.monitors', props.summary.WEEE3.MONITORS) }
          { renderRow('sortsummaryreports.import.resulttable.scrap', props.summary.WEEE3.SCRAP) }
          <tr>
            <th colSpan={7} scope="row" ><FormattedMessage id="sortsummaryreports.import.resulttable.WEEE4"/></th>
          </tr>
          { renderRow('sortsummaryreports.import.resulttable.ce', props.summary.WEEE4.CE) }
          { renderRow('sortsummaryreports.import.resulttable.crt', props.summary.WEEE4.CRT) }
          { renderRow('sortsummaryreports.import.resulttable.music', props.summary.WEEE4.MUSIC) }

          { renderRow('sortsummaryreports.import.resulttable.WEEE5', props.summary.WEEE5.LAMPS, true) }
          { renderRow('sortsummaryreports.import.resulttable.WEEE6', props.summary.WEEE6.EL_TOOLS, true) }
          { renderRow('sortsummaryreports.import.resulttable.WEEE7', props.summary.WEEE7.TOYS, true) }
          { renderRow('sortsummaryreports.import.resulttable.WEEE8', props.summary.WEEE8.HEALTH, true) }
          <tr>
            <th colSpan={7} scope="row"><FormattedMessage id="sortsummaryreports.import.resulttable.WEEE9"/></th>
          </tr>
          { renderRow('sortsummaryreports.import.resulttable.monitoring', props.summary.WEEE9.MONITORING_TOOLS) }
          { renderRow('sortsummaryreports.import.resulttable.firealarms', props.summary.WEEE9.FIRE_ALARMS) }
          <tr className="table-footer checksum">
            <th scope="row" className="sumHeader"><FormattedMessage id="transportsummaryreports.import.resulttable.total"/></th>
            <td className="valueCell"><div><FormattedNumber value={props.summary.TOTAL_EUR} maximumFractionDigits={2} minimumFractionDigits={2}/></div></td>
            <td><FormattedMessage id="sortsummaryreports.import.resulttable.eur"/></td>
            <td className="valueCell"><div><FormattedNumber value={props.summary.TOTAL_KG} maximumFractionDigits={2} minimumFractionDigits={2}/></div></td>
            <td><FormattedMessage id="sortsummaryreports.import.resulttable.kg"/></td>
            <td className="valueCell"><div><FormattedNumber value={calculateEurPerKg(props.summary.TOTAL_EUR, props.summary.TOTAL_KG)} maximumFractionDigits={3} minimumFractionDigits={3}/></div></td>
            <td><FormattedMessage id="sortsummaryreports.import.resulttable.eurKg"/></td>
          </tr>
        </tbody>
        </Table>
        </div>
        <div className="action-buttons">

          <button className="clear-button btn btn-secondary"
                  onClick={() => props.onCancel()}>
            <FormattedMessage id="transportsummaryreports.import.reject"/>
          </button>
          <button className="send-button btn btn-secondary"
                  onClick={() => props.onSend()}>
            <FormattedMessage id="transportsummaryreports.import.accept"/>
          </button>
        </div>

    </div>
  )
}

export default SorterSummaryPreview;
